export const [
  GET_STATISTICS_REQUEST,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_ERROR,
] = ["GET_STATISTIC_REQUEST", "GET_STATISTIC_SUCCESS", "GET_STATISTIC_ERROR"]
